import styled from 'styled-components'

import { ReactComponent as Cross } from '@sketch/icons/cross-17'

import { Form, LoadingPlaceholder } from '@sketch/components'

export const StyledField = styled(Form.Field)`
  position: relative;
  width: 100%;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.D};

  /* 
  * There's a padding transition in the Input component that is 
  * causing and odd behaviour in this case so we are removing it 
  */
  & [type='text'] {
    transition: none;
    /* Vertically center the text with the prefix */
    padding-bottom: 14px; /* stylelint-disable-line scales/space */
  }
`

export const StyledLoadingPlaceholder = styled(LoadingPlaceholder)`
  margin-right: 4px;
`

export const ErrorIcon = styled(Cross)`
  color: ${({ theme }) => theme.colors.state.negative.A};
`

export const FormError = styled(Form.Error)`
  margin-top: 6px; /* stylelint-disable-line scales/space */
`
